import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getTrees } from "./getTrees";
import { selectTree } from "./selectTree";

const treesQueryKey = ["trees"];

export const useTreesQuery = () =>
    useQuery({
        queryKey: treesQueryKey,
        queryFn: () => getTrees(),
    });

export const useSelectTreeMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (treeId: string) => selectTree(treeId),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: treesQueryKey }),
    });
};
